module.exports = __webpack_public_path__ + "static/img/4.810c767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/4.jpg
// module id = xW13
// module chunks = 1